import axios from 'axios';

const api = axios.create({
  baseURL: window.REACT_APP_ENDPOINT,
});

api.interceptors.response.use(
  response => response,
  error => {
    return Promise.reject(error);
  }
);

function getFormParams() {
  return window.location.pathname.split('/').filter(value => value !== '');
}

const getFormUrl = () => {
  const [formType, id] = getFormParams();
  return `${id}/${formType}`;
}

export const formGet = async () => {
  const url = getFormUrl();
  const request = api.get(url);
  let formResponse = null;
  let phoneField = false;

  return request
  .then((response) => {
    formResponse = response.data;
    phoneField = hasPhoneField(formResponse);
    if (phoneField) return api.get(url + '/phones/types')
    return Promise.resolve(formResponse);
  })
  .then((phoneTypes) => {
    if (phoneField) {
      formResponse = {...formResponse, PhoneTypes: [...phoneTypes.data]}
    } else {
      formResponse = {...formResponse}
    }
    return Promise.resolve(formResponse)
  })
  .catch(console.log)
}

const hasPhoneField = (data) => {
  const foundField = data.Fields.find(f => f.Field.SecondaryEntityId === 28);
  return foundField;
}

export const formGetColor = () => {
  const url = getFormUrl()+'?$select=Color';
  const request = api.get(url);

  request
  .then(response => response)
  .catch(e => console.log)
  .finally();

  return request;
}

export const formPost = (data) => {
  const url = getFormUrl();
  const request = api.post(url, data);

  request
  .then(response => response)
  .catch(e => console.log)
  .finally();

  return request;
}

export const filePost = (formData) => {
  const url = `attachments/${getFormUrl()}`;
  const request = api.post(url, formData);

  request
  .then(response => response)
  .catch(e => console.log);

  return request;
}

export const fileDelete = (attachmentId) => {
  const url = `attachments/${getFormUrl()}/${attachmentId}`;
  const request = api.delete(url);

  request
  .then(response => response)
  .catch(e => console.log);

  return request;
}

export const getCities = (search, page) => {
  const url = `${getFormUrl()}/cities?skip=${(page-1) * 10}&top=${10}&startswith=${search}`;
  return api.get(url);
}